<template>
  <div class="model_instance" v-if="Object.keys(modified_instance).length > 0">
    <div class="model_instance__header">
      <h4 class="title">
        {{ `${modified_instance.server_name} ${modified_instance.server_ip}:${modified_instance.port}` }}
      </h4>
    </div>

    <div class="model_instance__body">
      <div class="instance">
        <div class="line">
          <div class="input_wrap">
            <fg-input
                v-model="modified_instance.name"
                type="text"
                :label="translate('server.table_instance.name')"
                :placeholder="translate('server.table_instance.name')"
            />
          </div>

          <div class="input_wrap">
            <fg-input
                v-model="modified_instance.group_name"
                type="text"
                :label="translate('server.table_instance.group_name')"
                :placeholder="translate('server.table_instance.group_name')"
                :disabled="true"
            />
          </div>
        </div>

        <div class="line">
          <div class="input_wrap">
            <fg-input
                v-model="modified_instance.iperf_settings"
                type="text"
                :label="translate('server.table_instance.iperf_settings')"
                :placeholder="translate('server.table_instance.iperf_settings')"
            />
          </div>
        </div>

        <div class="line text_wrap">
          <div class="input_wrap form-group">
            <label>{{ translate('server.table_instance.description') }}</label>
            <textarea class="input_text" name="equipment" v-model="modified_instance.descr" rows="10" />
          </div>
        </div>

      </div>
    </div>
    <div class="model_instance__footer">
      <span
          :disabled="!has_changes"
          class="btn btn-success btn-fill btn-wd"
          @click.prevent="save_instance"
      >
        {{ translate('btn.edit') }}
      </span>
      <span
        class="btn btn-danger btn-fill btn-wd"
        @click.prevent="close_modal"
      >
        {{ translate('close_modal') }}
      </span>
    </div>

  </div>

  <div v-else>
    <div class="spinner">
      <scale-loader />
    </div>
  </div>

</template>
<script>

const fields_to_check = [
  "name",
  "iperf_settings",
  "descr"
];

export default {
  name: 'InstanceModal',
  props:[
    "instance_id",
    "start_url"
  ],
  data () {
    return {
      instance_info: {},
      modified_instance: {}
    }
  },
  computed:{
    has_changes() {
      let instance_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.instance_info[key];
        return obj;
      }, {});

      let modified_instance = fields_to_check.reduce((obj, key) => {
        obj[key] = this.modified_instance[key];
        return obj;
      }, {});

      return JSON.stringify(instance_info) !== JSON.stringify(modified_instance);
    }
  },

  created() {
    this.get_instance()
  },
  destroyed() {
    history.pushState(null, null, this.start_url)
  },

  methods: {
    get_instance(){
      this.$http.v1.getServerInstance(this.instance_id, (response) => {
        this.modified_instance = response.data
      })
    },
    save_instance(){
      if (this.has_changes){
        this.$http.v1.updateServerInstance(this.modified_instance.id, this.modified_instance, () => {
          this.global_notify('info', this.translate('server.table_instance.saved_instance_success'))
          this.$emit("update")
        })
      }
    },
    update(){
      this.$emit('update')
    },
    close_modal () {
      this.$emit('close')
    }
  }
}

</script>

<style lang='scss' scoped>
  .model_instance{
    height: 100%;
    padding: 10px;
    &__header{
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      .title{
        width: 100%;
        margin: 0;
        text-align: center;
      }
      .links{
        width: 30%;
        & > .vue-treeselect{
          margin-bottom: 0;
        }
      }
    }
    &__body{
      width: 100%;
      //height: 100%;
      //height: 600px;
      .instance{
        width: 100%;
        height: 100%;
        .line{
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          .input_wrap{
            width: 100%;
            text-align: start;
            margin-bottom: 10px;
          }

          .form-group,
          .vue-treeselect{
            margin-bottom: 0;
          }
        }
      }

    }
    &__footer{
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 10px;
      .btn{
        margin: 0 10px 0 0;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
  .pointer{
    cursor: pointer;
    &:hover{
      background-color: #f3f3f3;
    }
  }


</style>
